module.exports = __webpack_public_path__ + "img/info_icon.1705b013.svg";